import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { translate } from 'translations/translator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
const t = (key, options?) => translate('lessonPlanner', key, options);

type Props = {
  handlePreviousClick: () => void;
  handleNextClick: () => void;
  currentlessonPlanWeek: string | number;
};
export const ViewTeachingOrderActionNav: React.FC<Props> = ({
  handlePreviousClick,
  handleNextClick,
  currentlessonPlanWeek
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" padding={'20px 24px'}>
      <HwtButton
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handlePreviousClick}
      >
        <FontAwesomeIcon icon={faArrowLeft as any} style={{ marginRight: '10px' }} />
        {t('previousWeek')}
      </HwtButton>
      <Typography variant="h4">{t('week', { weekNumber: currentlessonPlanWeek })}</Typography>
      <HwtButton
        variant="contained"
        color="primary"
        className={classes.button}
        style={{ width: '10.6rem' }}
        onClick={handleNextClick}
      >
        {t('nextWeek')}
        <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '10px' }} />
      </HwtButton>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  button: {
    whiteSpace: 'nowrap'
  }
}));
